import React from "react";

const experiences = [
  {
    id: 1,
    company: "Frontend website development",
    // role: "Frontend Developer",
    duration: "2 Weeks",
    period: "",
    status: "completed",
    description:
      "A Frontend website development service that transforms your vision into a stunning online presence. I specialize in crafting visually captivating and user-friendly websites using cutting-edge technologies. With a focus on responsive design, seamless navigation, and engaging user experiences, I bring your ideas to life with precision and creativity. Whether you need a portfolio, business site, or e-commerce platform, I deliver high-quality results that exceed expectations.",
    technologies: [
      "TypeScript",
      "JavaScript",
      "Node.js",
      "React",
      "Next.js",
      "Animation using Framer and GSAP",
    ],
    achievements: [],
    color: "from-purple-500 to-pink-500",
    position: 0,
  },
];

const Page6 = () => {
  const currentExperience = experiences[0];

  return (
    <div className="md:pb-10 px-4  overflow-hidden">
      <div className="h-full w-full overflow-hidden rounded-[50px] relative border border-white/10">

        {/* Background */}
        <div className="h-full w-full overflow-hidden rounded-[50px] relative">
          <div
            className="absolute top-0 left-0 w-full h-full bg-cover bg-center
                       max-[768px]:bg-scroll"
            style={{
              backgroundImage: "url('experience-bg.jpg')",
              backgroundAttachment: "fixed",
            }}
          />

          {/* Header */}
          <div className="relative z-10 text-center pt-12 max-[640px]:pt-8 max-[640px]:pb-4">
            <h1
              className="
                text-4xl md:text-9xl
                max-[640px]:text-6xl
                font-bold text-transparent bg-clip-text font-[anzo]
                bg-gradient-to-r from-white via-blue-300 to-purple-200
              "
            >
              SERVICE
            </h1>

            
          </div>

          {/* Content */}
          <div
            className="
              relative z-10 flex items-center justify-center px-8
              h-[calc(100vh-280px)]
              max-[768px]:h-auto
              max-[768px]:pb-10
            "
          >
            <div className="max-w-2xl w-full">
              <div className="relative bg-black/40 backdrop-blur-lg border border-white/20 rounded-2xl p-6 max-[640px]:p-4 shadow-2xl">

                {/* Company */}
                <div className="mb-5">
                  <div className="flex items-center justify-between mb-2">
                    <h3 className="text-2xl max-[640px]:text-lg font-bold text-white/90">
                      {currentExperience.company}
                    </h3>

                    <a
                      href="#HireMe"
                      className="px-3 py-1 rounded-full text-xs font-semibold text-center
                                 bg-blue-200/20 text-blue-300 border border-blue-500/30"
                    >
                      CONTACT FOR PRICING
                    </a>
                  </div>

                  <p className="text-xl max-[640px]:text-base text-white/90 mb-2">
                    {currentExperience.role}
                  </p>

                  <div className="flex flex-wrap gap-2 text-white/60 text-sm">
                    <span className="flex items-center">
                      <div className="w-2 h-2 bg-blue-300 rounded-full mr-2" />
                      {currentExperience.duration}
                    </span>
                  </div>
                </div>

                {/* Description */}
                <p className="text-white/80 mb-5 leading-relaxed max-[640px]:text-sm">
                  {currentExperience.description}
                </p>

                {/* Tech */}
                <div className="mb-5">
                  <h4 className="text-white/90 font-semibold mb-3">
                    Technologies
                  </h4>

                  <div className="flex flex-wrap gap-2">
                    {currentExperience.technologies.map((tech, i) => (
                      <span
                        key={i}
                        className="px-3 py-1 bg-white/10 text-blue-300 rounded-full text-xs md:text-sm border border-white/20"
                      >
                        {tech}
                      </span>
                    ))}
                  </div>
                </div>

                {/* Hover overlay (unchanged) */}
                <div className="absolute inset-0 bg-gradient-to-br from-white/0 to-white/5 opacity-0 hover:opacity-100 transition-opacity rounded-2xl pointer-events-none" />
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};

export default Page6;
